module.exports = __webpack_public_path__ + "img/P3.a23c4bb4.jpg";